export enum ObjectUpdatedType {
  PROPERTY = 'PROPERTY',
  NOTES = 'NOTES',
  DOC = 'DOC',
  PHOTO = 'PHOTO',
  EVENT = 'EVENT',
  COMSUMPTION = 'COMSUPTION',
  MAINTENANCE = 'MAINTENANCE',
  WORK = 'WORK',
  EQUIPMENT = 'EQUIPMENT',
  CUSTOM_CONTACT = 'CUSTOM_CONTACT',
  SERVICE = 'SERVICE',
  SALE = 'SALE',
  ATTRIBUTE = 'ATTRIBUTE',
  SHARE = 'SHARE'
}
